import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@chakra-ui/react'
import { useGetUserSelector } from 'core/redux/selectors/authSelectors'
import { useTranslation } from 'helpers/languages/translations'
import { useState, useEffect } from 'react'
import pusher from '../pusher'

const SSOAutoLogout = () => {
  const [loggedOut, setLoggedOut] = useState(false)
  const userInfo = useGetUserSelector();
  const username = userInfo?.original_user

  const translate = useTranslation()
  useEffect(() => {
    if (!username) return
    console.log(username)
    const channel = pusher.subscribe(`private-cdm-logout-${username}`)
    channel.bind('forced-logout', function(data: string) {
      if (data === username) {
        setLoggedOut(true)
      }
    })
    return () => {
      channel.unsubscribe()
    }
  }, [username])
  return (
    <Modal isOpen={loggedOut} onClose={() => { }}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{translate('autoLogout.title')}</ModalHeader>
        <ModalBody>{translate('autoLogout.content')}</ModalBody>

        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={() => {
              window.location.reload()
            }}
          >
            {translate('autoLogout.refresh')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default SSOAutoLogout
